const services = [
    {
        title: "Interessenvertretung",
        text: "An oberster Stelle steht die Interessenvertretung unserer Mitglieder gegenüber den gesetzlichen Kostenträgern, Versicherungen, Kammern und kassenärztlichen Vereinigungen."
    },
    {
        title: "Spezialistensuche",
        text: "Ordentliche Mitglied werden in einer Spezialistensuche auf unserer Website geführt: Über eine postleitzahlenbasierte Suchfunktion finden Patienten den kompetenten Proktologen in ihrer Nähe."
    },
    {
        title: "Kompetenzzentren",
        text: "Ordentliche Mitglieder in Praxen, Versorgungszentren und Klinikabteilungen können eine Anerkennung als Kompetenzzentrum beantragen."
    },
    {
        title: "Ansprechpartner",
        text: "Unterstützung bei allen aktuellen Fragen zur vertrags- und privatärztlichen Honorierung sowie Unterstützung bei juristischen Auseinandersetzungen."
    },
    {
        title: "BCD-Seminare",
        text: "Um den hohen Anspruch einer fachlichen Qualifikation zu erfüllen, sind kontinuierliche Fort- und Weiterbildungen, kollegialer und fachlicher Austausch unabdingbar: Im Rahmen des Koloproktologen-Kongresses ist die Teilnahme am Berufspolitischen Seminar für Mitglieder inklusive."
    },
    {
        title: "BZH-Basisberatung",
        text: "Bei Fragen zur Hygiene und Infektionsprävention steht Ihnen ein interdisziplinäres Team zur Verfügung."
    },
    {
        title: "Coloproctology",
        text: "Seit 1. Januar 2026 ist die Fachzeitschrift Coloproctology in der Mitgliedschaft enthalten."
    },
    {
        title: "Sonderkonditionen",
        text: "Einkaufsvorteile nutzen über die Einkaufsplattform des bng."
    }
];

export default services;
